import { IAppState } from "../app.state";

export const selectUser = (state: IAppState) => state.user;

export const selectPartner = (state: IAppState) => state.user.partner;
